import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	copy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copied: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	copy: {
		id: 'native-issue-table.common.issue-cells.issue-key.copy-issue-link.copy',
		defaultMessage: 'Copy link',
		description: 'Message indicating that the action is to copy a link',
	},
	copied: {
		id: 'native-issue-table.common.issue-cells.issue-key.copy-issue-link.copied',
		defaultMessage: 'Copied',
		description: 'Message indicating that the action to copy a link has been completed',
	},
});
export default messages;
